import {FC} from 'react'
import {useIntl} from 'react-intl'

/**
 * Shared multi-supplier offer indicators, extracted from OfferTableRow so
 * the same visual language can be reused across the product list, reports,
 * and any other surface that shows a supplier's offer (T1 foundation).
 */

/** Buy-box winning star — gold when winning, grey outline otherwise. */
export const WinningStar: FC<{winning: boolean}> = ({winning}) => {
  const {formatMessage} = useIntl()
  return winning ? (
    <span
      title={formatMessage({id: 'offers.row.winning_tooltip'})}
      style={{color: '#f59e0b', fontSize: 18, lineHeight: 1}}
      aria-label={formatMessage({id: 'offers.row.winning_aria'})}
    >
      ★
    </span>
  ) : (
    <span style={{color: '#d1d5db', fontSize: 18, lineHeight: 1}} aria-hidden="true">
      ☆
    </span>
  )
}

/** Small red dot shown next to a price the admin has overridden. Renders
 *  nothing when there's no override. The override VALUE never reaches the
 *  client — only this boolean flag. */
export const AdminOverrideDot: FC<{active: boolean}> = ({active}) => {
  const {formatMessage} = useIntl()
  if (!active) return null
  return (
    <span
      className="ms-1"
      style={{color: '#b91c1c', fontSize: 14, lineHeight: 1}}
      title={formatMessage({id: 'offers.row.admin_override_tooltip'})}
      aria-label={formatMessage({id: 'offers.row.admin_override_aria'})}
    >
      ●
    </span>
  )
}
